import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { updateTcOrder } from 'actions/tc/orders';

const typeTerms = [
    'POL dets:',
    'POD dets:',
    'POL/POD dets:',
    'Laycan dets:',
    'Load dets:',
    'Disch dets:',
    'L/D dets:',
    'Comm dets:',
    'Freight dets:',
    'Vessel dets:',
    'Packing dets:',
    'Additional dets:',
    'Cargo dets:',
];

class Terms extends React.PureComponent {

    removeTerm = (number) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.terms.user.splice(number, 1);

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    addNewTerm = () => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.terms.user.push({ type: '', value: '' });

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    onChangeTypeTerm = (key, numberElement) => {        
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.terms.user[numberElement].type = typeTerms[key];

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    onChangeTerm = (value, numberElement) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);
        
        _tcOrder.terms.user[numberElement].value = value;
        
        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    render() {
        const { terms: { user = [] } } = this.props.tcOrder;

        return (
            <div>
                <div className='row'>
                    <div className='column-left'>
                        Terms:
                    </div>
                    <div className='column-right'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new term'
                            onClick={this.addNewTerm}
                            primary
                        />
                    </div>
                </div>
                {
                    user.map((term, key) => {
                        return (
                            <div key={`term_${key}`} className='row'>
                                <div className='column-left'>
                                    {`Term ${key}`}
                                </div>
                                <div className='column-right'>
                                    <SelectField
                                        style={{
                                            padding: '0 5px',
                                            width: '80%',
                                            fontSize: '13px',
                                        }}
                                        value={term.type}
                                        onChange={(e, numberSelected) => {
                                            this.onChangeTypeTerm(numberSelected, key);
                                        }}
                                        maxHeight={200}
                                        autoWidth
                                    >
                                        {
                                            typeTerms.map((typeTerm, i) => {
                                                return (<MenuItem
                                                    key={i}
                                                    style={{ width: 'auto', fontSize: '13px' }}
                                                    value={typeTerm}
                                                    primaryText={typeTerm}
                                                />);
                                            })
                                        }
                                    </SelectField>
                                    <TextField
                                        style={{ fontSize: '13px' }}
                                        value={term.value || ''}
                                        hintText={`Term ${key}`}
                                        onChange={(e) => { return this.onChangeTerm(e.target.value, key); }}
                                    />
                                    <RaisedButton
                                        labelStyle={{ fontSize: '10px' }}
                                        style={{ height: '25px' }}
                                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                        label='Remove term'
                                        onClick={() => { return this.removeTerm(key); }}
                                        secondary
                                    />
                                </div>
                            </div>);
                    })
                }
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {};
    },
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(Terms);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/Terms.jsx